import { FC, useCallback } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  SelectChangeEvent,
  Box,
  Typography,
} from '@mui/material';
import { PolicyFixInput } from '../../../../types/issues-types';
import InfoIcon from '../../../../../../elements/InfoIcon/InfoIcon';

const RadioInput: FC<React.PropsWithChildren<RadioProps>> = props => {
  const { displayName, name, onChange, options } = props;

  const onChangeCall = useCallback(
    (event: SelectChangeEvent<string[]>) => {
      onChange(name, event.target.value);
    },
    [name, onChange],
  );
  return (
    <FormControl variant='standard' fullWidth>
      <FormLabel
        sx={{ textTransform: 'capitalize' }}
        id='demo-radio-buttons-group-label'>
        {displayName}
      </FormLabel>
      <RadioGroup
        aria-labelledby='demo-radio-buttons-group-label'
        onChange={onChangeCall}
        value={options.filter(o => o.selected).map(o => o.name)}
        name='radio-buttons-group'>
        {options.map(({ name, displayName, info }) => (
          <Box
            key={name}
            display='flex'
            flexDirection='row'
            alignItems='center'>
            <FormControlLabel
              value={name}
              control={<Radio />}
              label={displayName}
            />
            {info && (
              <InfoIcon
                title={
                  <Typography variant='caption' color='text.secondary'>
                    {info}
                  </Typography>
                }
              />
            )}
          </Box>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export interface RadioProps extends PolicyFixInput {
  onChange: (type: string, input: string | string[]) => void;
}

export default RadioInput;
